// Recovered compiled webpack factory 86278. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let a = r(28140)._(r(1150));
  function n(e, t) {
    var r;
    let n = {};
    "function" == typeof e && (n.loader = e);
    let l = { ...n, ...t };
    return (0, a.default)({
      ...l,
      modules: null == (r = l.loadableGenerated) ? void 0 : r.modules,
    });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
